import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import AlertDialog from "../../AlertDialog";
import { baseUrl, mainBaseUrl } from "../../App";
import "../Styles/AdminDashboard.scss";
import AcceptButton from "./AcceptButton";
import RejectButton from "./RejectButton";
import RejectionRollback from "./RejectionRollback";
import VerifyRollback from "./VerifyRollback";

const AdminDashboard = ({
  certificatePool,
  rejected,
  getRejectedInfo,
  getInfo,
  profileCode,
  profile,
}) => {
  const [btnController, setBtnController] = useState("all");
  const history = useHistory();

  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   console.log(profile);
  // }, []);

  const deleteRejected = (id) => {
    setLoading(true);
    var config = {
      method: "delete",
      url: `${mainBaseUrl}/rejectPool/event/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        alert("Rejected Certificate Deleted");
        closeDialog();
        window.location.reload();
        console.log(response.data);
      })
      .catch(function (error) {
        setLoading(false);
        alert("There's some problem in deleting the certificate");
        closeDialog();
        console.log(error.response.data);
      });
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const roteChange = (cert) => {
    history.push({
      pathname: "/certificateDetails",
      state: { cert: cert, admin: true, profile: profile["email"] },
    });
  };
  if (localStorage.getItem("token") === null) {
    return <Redirect to="/" />;
  }
  if (profileCode === true) {
    localStorage.removeItem("token");
    return <Redirect to="/" />;
  }

  return (
    <div className="admin-dashboard">
      <p className="title-admin">Dashboard</p>
      <button
        onClick={() => {
          setBtnController("all");
          getInfo();
        }}
        style={{
          backgroundColor: `${
            btnController === "all" ? "#1f0e32" : "#efefef"
          } `,
          color: `${btnController === "all" ? "white" : "black"} `,
        }}
        className="controller-btn"
      >
        All
      </button>
      <button
        onClick={() => {
          setBtnController("rejected");
          getRejectedInfo();
        }}
        style={{
          backgroundColor: `${
            btnController === "rejected" ? "#1f0e32" : "#efefef" // add separete color for rejected!!!!
          } `,
          color: `${btnController === "rejected" ? "white" : "black"} `,
        }}
        className="controller-btn" // maja aagaya
      >
        Rejected
      </button>
      {certificatePool.lenght === 0 ? (
        <h1>Loading...</h1>
      ) : btnController === "all" ? ( // if all is selected then show all certificates
        <div className="containers-admin">
          {certificatePool.map((certificate, ind) => (
            <div key={ind} className="container-admin">
              <p>
                {" "}
                <b>Event name:</b> {certificate["eventName"]}
              </p>
              <p>
                <b> Description :</b> {certificate["description"]}
              </p>
              <p>
                {" "}
                <b>Speaker Name :</b> {certificate["speakerName"]}
              </p>
              <p>
                <b>Event Date :</b> {certificate["eventDate"]}
              </p>
              <p>
                <b>Published By :</b> {certificate["publishedBy"]["name"]}
              </p>
              {certificate["rejected"] ? (
                <p>
                  <b>Status</b> : Rejected
                </p>
              ) : (
                <p>
                  <b>Status</b> :{" "}
                  {certificate["verified"] ? "Verified" : "Pending"}
                </p>
              )}
              <p>
                <b>Total Certificates :</b> {certificate["certificates"].length}
              </p>

              <p
                onClick={() => {
                  roteChange(certificate);
                }}
                style={{ cursor: "pointer" }}
              >
                <b style={{ color: "blue" }}>
                  Click here for Certificates List
                </b>
              </p>
              <AcceptButton
                eventData={certificate}
                getInfo={getInfo}
                eventID={certificate["eventID"]}
                isVerified={certificate["verified"]}
              />
              {certificate["verified"] ? (
                <VerifyRollback
                  getInfo={getInfo}
                  eventID={certificate["eventID"]}
                />
              ) : (
                ""
              )}
              {certificate["verified"] ? (
                ""
              ) : (
                <RejectButton
                  getInfo={getInfo}
                  eventID={certificate["eventID"]}
                  isRejected={certificate["rejected"]}
                />
              )}
              {/* {certificate["rejected"] ? (
                <button className="adminButton">Rollback Rejection</button>
              ) : (
                ""
              )} */}
            </div>
          ))}
        </div>
      ) : (
        <div className="containers-admin">
          {rejected.map((rej) => (
            <div key={rej["eventID"]} className="container-admin">
              <p>
                {" "}
                <b>Event name:</b> {rej["eventName"]}
              </p>
              <p>
                <b> Description :</b> {rej["description"]}
              </p>
              <p>
                {" "}
                <b>Speaker Name :</b> {rej["speakerName"]}
              </p>
              <p>
                <b>Event Date :</b> {rej["eventDate"]}
              </p>

              {rej["rejected"] ? (
                <p>
                  <b>Status</b> : Rejected
                </p>
              ) : (
                <p>
                  <b>Status</b> : {rej["verified"] ? "Verified" : "Pending"}
                </p>
              )}

              <p>
                <b>Total Certificates :</b> {rej["certificates"].length}
              </p>
              <p
                onClick={() => {
                  roteChange(rej);
                }}
                style={{ cursor: "pointer" }}
              >
                <b style={{ color: "blue" }}>
                  Click here for Certificates List
                </b>
              </p>
              {/* <AcceptButton
                eventID={rej["eventID"]}
                isVerified={rej["verified"]}
              /> */}
              {rej["verified"] ? (
                <VerifyRollback eventID={rej["eventID"]} />
              ) : (
                ""
              )}
              {/* <RejectButton
                eventID={rej["eventID"]}
                isRejected={rej["rejected"]}
              /> */}
              <AlertDialog
                title="Delete Rejected Certificate"
                description="Do you really want to delete rejected data?"
                handleClose={closeDialog}
                open={open}
                onAgree={() => deleteRejected(rej["eventID"])}
                isLoading={loading}
              />
              <button
                onClick={() => setOpen(true)}
                style={{
                  height: "2.2rem",
                  backgroundColor: "tomato",
                  padding: "10px",
                  marginTop: "10px",
                  outlineStyle: "none",
                  borderStyle: "none",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: "5px",
                }}
              >
                Delete
              </button>
              {rej["rejected"] ? (
                <RejectionRollback
                  getRejectedInfo={getRejectedInfo}
                  eventID={rej["eventID"]}
                />
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
